/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Signed_In_AsInputs */

const en_auth_login_signed_in_as = /** @type {(inputs: Auth_Login_Signed_In_AsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signed in as`)
};

/**
* | output |
* | --- |
* | "Signed in as" |
*
* @param {Auth_Login_Signed_In_AsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const auth_login_signed_in_as = /** @type {((inputs?: Auth_Login_Signed_In_AsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Signed_In_AsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_auth_login_signed_in_as(inputs)
});